module.exports = __webpack_public_path__ + "img/abhi.a0721770.png";